import { TrackingApi } from 'api/TrackingApi';
import { getScreenOrientationWithSizes } from 'helpers/device';

export const useMatchPopupAnalytics = () => {
  const EVENT_NAME = 'mutual_like';

  const trackPopupShow = (payload: { contactId: number }) => {
    TrackingApi.trackPopup({
      info: EVENT_NAME,
      operation: 'show',
      value: payload.contactId,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  };

  const trackPopupClose = (payload: { contactId: number }) => {
    TrackingApi.trackPopup({
      info: EVENT_NAME,
      operation: 'close',
      value: payload.contactId,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  };

  const trackPopupType = (payload: { contactId: number }) => {
    TrackingApi.trackPopup({
      info: EVENT_NAME,
      operation: 'type',
      value: payload.contactId,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  };

  const trackPopupSend = (payload: { contactId: number }) => {
    TrackingApi.trackPopup({
      info: EVENT_NAME,
      operation: 'send',
      value: payload.contactId,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  };

  const trackPopupClick = (payload: {
    messageId?: number;
    contactId: number;
  }) => {
    TrackingApi.trackPopup({
      info: EVENT_NAME,
      operation: 'click',
      parameter: payload.messageId ? String(payload.messageId) : '',
      value: payload.contactId,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  };

  return {
    trackPopupShow,
    trackPopupClose,
    trackPopupType,
    trackPopupSend,
    trackPopupClick,
  };
};
